import $ from 'jquery';
import HouseData from './houseInfo.js';
import { CSRF } from 'mdlib';

class Request {
    constructor(data = {}) {
        this.data = data;
        this.xhr = null;
        this.response = undefined;
        this.result = undefined;
    }

    get count() {
        const response = this.response || {};

        return response.objects_count || 0;
    }

    get total() {
        const response = this.response || {};

        return response.total_count || 0;
    }

    make() {
        return new Promise((resolve, reject) => {
            let data = {
                entity: 'house',
            };
            let method = 'GET';

            if (this.data.street_id) {
                data = Object.assign(data, {
                    street: this.data.street_id,
                });
            }

            if (this.data.query) {
                data = Object.assign(data, {
                    query: this.data.query,
                });
            }

            if (this.data.limit !== undefined) {
                data = Object.assign(data, {
                    limit: this.data.limit,
                });
            }

            if (this.data.polygon) {
                method = 'POST';
                data = Object.assign(
                    data,
                    {
                        polygon: this.data.polygon,
                    },
                    CSRF.getByObject()
                );
            }

            this.xhr = $.ajax({
                method,
                url: '/location/map',
                data,
                complete: () => {
                    this.xhr = null;
                },
                success: (response = {}) => {
                    if (response.status !== 'ok') {
                        reject(response.message || 'Ошибка при загрузке');
                        return;
                    }

                    const responseData = response.response || {};
                    const houses = responseData.objects || [];
                    const result = houses.map((house) => new HouseData(house));

                    this.response = responseData;
                    this.result = result;

                    resolve(result);
                },
                error: (x, h, message) => {
                    if (message === 'abort') {
                        reject(false);
                        return;
                    }

                    console.error(message);
                    reject('Ошибка загрузки');
                },
            });
        });
    }

    abort() {
        if (this.xhr) {
            this.xhr.abort();
            this.xhr = null;
        }
    }
}

class Houses {
    prepareRequest(data = {}) {
        return new Request(data);
    }

    get(data = {}) {
        var request = this.prepareRequest(data);

        return request.make();
    }

    prepareData(house) {
        return new HouseData(house);
    }
}

export default new Houses();
